import { Time } from '@angular/common';

export class tPurchaseOrderModel {

    id: number;
    
    shopID: string;
    poNumber: string;
    poDate: Date;

    poPoNumber: string;
    poVendorInvoiceNumber: string;
    poVendorCode: string;
    poVendorName: string;

    poDefaultWarehouseID: string;
    poItemType: number;
    poAPAmt: number;

    poLineRemark:string;
    poItemID: string;
    poItemName: string;
    poPurchUnitPrice: number;
    poPurchQty: number;
    poPurchaseUnit: number;
    poMediConvQty: number;
    poStockQty: number;
    poStockUnit: number;
    poPurchLineAmt: number;

    LastModifyDatetime: Date;
    LastModifyUserID: string;
    CreateDatetime:Date;
    CreateUserID: string;
    poRequestDeliveryDate:Date;
    poPromiseDeliveryDate:Date;
    selected:string;
}

export class tPurchaseOrderModelwithWHName extends tPurchaseOrderModel { 
    poWarehouseName: string;
 }

export class POItemBalance{
    grnVendorCode:string;
    grnPoNumber:string;
    grnItemID:string;
    usedQty:number;
}

export class SearchPODialogListProps extends tPurchaseOrderModel { 
    itemBalance:number;
}